import { Chip, styled, Tooltip } from '@ethings/ui-toolkit';
import { useMediaQuery, useTheme } from '@mui/material';
import { FC } from 'react';
import { useResponsiveText } from '../../hooks';

interface Props {
  backgroundColor?: string;
  color?: string;
  'data-testid'?: string;
  label: string;
  tooltipTitle: string;
  disabled?: boolean;
}

interface StyledChipProps {
  backgroundColor?: string;
  chipColor?: string;
}

const StyledChip = styled(Chip)<StyledChipProps>(({ backgroundColor, chipColor }) => ({
  backgroundColor,
  color: chipColor,
}));

export const HeroChip: FC<Props> = ({
  backgroundColor,
  color,
  label,
  tooltipTitle,
  disabled,
  ...props
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const labelStyles = useResponsiveText('0.875rem', label.length, {
    minFontSize: '0.75rem',
    maxFontSize: '0.875rem',
    textLengthThreshold: 20,
  });

  const iconSize = isSmallScreen ? '0.875rem' : '1rem';

  return (
    <Tooltip arrow title={tooltipTitle} placement="top">
      <StyledChip
        data-testid={props['data-testid']}
        label={label}
        disabled={disabled}
        backgroundColor={backgroundColor}
        chipColor={color}
        sx={{
          '& .MuiChip-label': {
            fontSize: labelStyles.fontSize,
            lineHeight: labelStyles.lineHeight,
            wordBreak: labelStyles.wordBreak,
            whiteSpace: labelStyles.whiteSpace,
            overflow: labelStyles.overflow,
            textOverflow: labelStyles.textOverflow,
          },
          '& .MuiChip-icon': {
            fontSize: iconSize,
          },
        }}
      />
    </Tooltip>
  );
};
